import { GoTriangleRight } from 'react-icons/go';
import { Button, ButtonProps } from '@inexture/core';
import { FC } from 'react';
import { openModal } from '@inexture/modals';
import RegisterForm from '@/form/register/RegisterForm.tsx';

const RFTrigger: FC<{ title?: string; btnProps?: ButtonProps }> = ({
  title = 'GRATIS account aanmaken',
  btnProps
}) => {
  return (
    <div>
      <Button
        onClick={() => {
          openModal({
            transitionProps: { transition: 'fade', duration: 300 },
            centered: true,
            withCloseButton: false,
            closeOnEscape: true,
            closeOnClickOutside: true,
            size: 380,
            styles: { body: { padding: 0, background: '#f5f3ea' } },
            children: <RegisterForm />,
            withinPortal: false
          });
        }}
        size="md"
        rightSection={<GoTriangleRight size={20} />}
        {...btnProps}
      >
        {title}
      </Button>
    </div>
  );
};

export default RFTrigger;
